import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, featureName } from './auth.state';

const getState = createFeatureSelector<State>(featureName);
export const getLoggedIn = createSelector(
  getState,
  state => state.loggedIn
);
export const getUserProfile = createSelector(
  getState,
  state => state.userProfile
);
